import {
  AvatarVariant,
  SpeakerAvatarVariant,
} from "@/states/call/speakers/speakers.utility.decl";

export const TAGS_DARK_COLORS = [
  "#000000",
  "#003D4C",
  "#BB2100",
  "#F92C00",
  "#008f6c",
  "#0662B5",
];

export const NEW_TAGS_COLORS = [
  "#003D4C",
  "#BB2100",
  "#F92C00",
  "#0662B5",
  "#008f6c",
  "#29C8FF",
  "#B285D1",
  "#FCBB26",
  "#FF9D88",
  "#FF854C",
  "#ACCCF3",
  "#48A0FF",
  "#65D289",
];

export const BRAND_COLORS = {
  BLUE: {
    LIGHT: "#EDF3FA",
    DARK: "#005ABB",
  },
};

export const FONT_SIZE_BASE_VALUE = 14;

// V2
export const AVATAR_VARIANTS: AvatarVariant[] = [
  "default",
  "blue",
  "green",
  "yellow",
  "purple",
  "pink",
];

export const ILLUSTRATION_BACKGROUND_COLORS = {
  LIGHT_BLUE: "#E1F4FF",
  LIGHT_YELLOW: "#FFFBF0",
  LIGHT_RED: "#FFF5F3",
  LIGHT_GREEN: "#F1FFFC",
  GREEN: "#D0ECE4",
};

/**
 * The exact tractor color tokens previously typed via `ThemeColor<DefaultTheme>`.
 * Kept as a narrow string-literal union so downstream tractor consumers
 * (Typography `color`, `ThemeColor<DefaultTheme>`) still accept these values.
 */
type SpeakerColorToken =
  | "primary-500"
  | "informative-500"
  | "warning-500"
  | "decorative1-600"
  | "decorative2-600";

export const SPEAKERS_COLORS: Record<SpeakerAvatarVariant, SpeakerColorToken> =
  {
    green: "primary-500",
    blue: "informative-500",
    yellow: "warning-500",
    purple: "decorative1-600",
    pink: "decorative2-600",
  };

/**
 * Speaker colours for the migrated `@aircall/ds` UI (left panel).
 * Each value references a live DS palette token (defined in
 * `@aircall/ds/globals.css` `:root`), so it works both as an inline
 * `style` value and inside a `bg-[var(--…)]` arbitrary utility. The closest
 * DS step to each former Tractor colour was chosen (yellow-400 over the more
 * orange yellow-500; purple-600 ≈ the old decorative1; pink-500 is an exact
 * match for the avatar pink).
 *
 * `SPEAKERS_COLORS` above is kept for the not-yet-migrated Tractor consumers
 * (Title headings, right-panel Transcription / Player), which still feed a
 * theme-token name into Tractor's `color` prop.
 */
export const SPEAKER_VARIANT_COLOR: Record<SpeakerAvatarVariant, string> = {
  green: "var(--color-green-500)",
  blue: "var(--color-blue-500)",
  yellow: "var(--color-yellow-400)",
  purple: "var(--color-purple-600)",
  pink: "var(--color-pink-500)",
};

export type AssetsColors = "green" | "yellow";
